// components/relatorio-skeleton/index.tsx
import React from 'react';
import Skeleton from 'react-loading-skeleton';

const RelatorioSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col gap-6 mt-8">
      {[1, 2].map(i => (
        <div key={i} className="border border-solid border-gray-200 rounded-lg overflow-hidden">
          <div className="bg-contrast px-4 py-3 flex flex-wrap gap-x-8 gap-y-1">
            {[1, 2, 3, 4].map(j => (
              <div key={j} className="flex flex-col gap-1">
                <Skeleton width={60} height={10} />
                <Skeleton width={100} height={14} />
              </div>
            ))}
          </div>

          <div className="divide-y divide-solid divide-gray-100">
            {[1, 2, 3].map(k => (
              <div key={k} className="px-4 py-4 bg-white border-t border-solid border-gray-200 flex flex-col gap-2">
                <div className="flex flex-wrap items-center gap-x-6 gap-y-1">
                  <Skeleton width={50} height={18} />
                  <Skeleton width={90} height={14} />
                  <Skeleton width={140} height={14} />
                  <Skeleton width={120} height={14} />
                  <Skeleton width={80} height={20} className="!rounded-full ml-auto" />
                </div>

                <div className="flex flex-col gap-1">
                  {[1, 2].map(p => (
                    <Skeleton key={p} height={36} className="!rounded" />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default RelatorioSkeleton;